import React from "react";
import { HashRouter  as Router, Routes, Route, Link } from "react-router-dom";
import Motion from "framer-motion";
import "../CSS/About.css";
import doubleArrow from "../Resources/Images/DoubleArraw.svg";
import developer from "../Resources/Images/Developercreatordesigner.svg";
import eclips from "../Resources/Images/Ellipse 1.svg";
import react from "../Resources/Images/React.svg";
import spring from "../Resources/Images/Spring.svg";
import java from "../Resources/Images/Java.svg";
import python from "../Resources/Images/Python.png";
import figma from "../Resources/Images/Figma.svg";
import photoshop from "../Resources/Images/Photoshop.svg";
import rachelsFashion from "../Resources/Images/RachelsFashion.png";
import boy from "../Resources/Images/Boy.png";
import evertea from "../Resources/Images/EverTea.jpg";
import everTeaWeb from "../Resources/Images/EverTea.png";
import ticketingSystem from "../Resources/Images/TicketingSystem.png";
import zain from "../Resources/Images/ZainBillBoard.png";
import skateboard from "../Resources/Images/Orange Blue Illustrated Skateboard Hoodie.png";


const About: React.FC = () => {
  return (
    <div className="htmlOverflow">
      <section className="aboutPage">
        <div className="aboutPageSection">
          <p className="mainTopic">Designing <br></br>With Purpose</p>
          <p className="subTopic">With a passion for innovation and an eye for design, 
            we bring ideas to life, shaping the digital future with precision and creativity. 
            Every project is a step toward a smarter, more connected world.
          </p>
          <div className="contactMeShortCut">
            <img src={doubleArrow} alt="Arrows" />
            <Link to="/contact">Get Started</Link>
          </div>
        </div>
      </section>

      <section className="projects">
        <div className="projectsboarderCenter">
          <img src={evertea} alt="EverTea Project" />
          <img src={zain} alt="Zain BillBoard" />
          <img src={skateboard} alt="Orange Blue Illustrated Skateboard Hoodie" />
          <img src={everTeaWeb} alt="EverTea Project" />
        </div>
      </section>

      <section className="about">
        <div className="boarderCenter">
          <p className="aboutTopic">Gerald Fernand0</p>
          <div className="aboutParagraph">
            <p>
              I am <span className="highlight">Gerald Fernando</span>, a passionate <span className="highlight">developer</span> and <span className="highlight">designer</span> who thrives at the intersection of technology and creativity. With a strong foundation in <strong>web</strong>,<strong>software development</strong>, <strong>UI/UX design</strong>, and <strong>multimedia production</strong>, I bring a <span className="highlight">unique</span> blend of <span className="aboutMeContentHighlight">functionality and aesthetics</span> to every project I work on.
            </p>
          </div>
          <div className="CardBoarderCenter">
            <div className="cardContainer">
              <p className="cardNumber">01</p>
              <h2 className="cardTitle">Loyola College<br></br>2012-2022<br></br><br></br></h2>
              <div className="tagContainer">
                <span className="tag">O/L's</span>
                <span className="tag">A/L's</span>
              </div>
              <span className="breaker"><br></br></span>
              <button className="plusButton">+</button>
            </div>
            <div className="cardContainer">
              <p className="cardNumber">02</p>
              <h2 className="cardTitle">Westminster University<br></br>2023-2027<br></br><br></br></h2>
              <div className="tagContainer">
                <span className="tag">Java</span>
                <span className="tag">Web Development</span>
                <span className="tag">Python</span>
                <span className="tag">Algorithm Creating</span>
              </div>
              <button className="plusButton">+</button>
            </div>
            <div className="cardContainer">
              <p className="cardNumber">03</p>
              <h2 className="cardTitle">Informatics Institute of Technology<br></br>2022-2023<br></br></h2>
              <div className="tagContainer">
                <span className="tag">Python</span>
                <span className="tag">Web Development</span>
              </div>
              <span className="breaker"><br></br></span>
              <button className="plusButton">+</button>
            </div>
            </div>
            <div className="CardBoarderCenter">
              <div className="cardContainer">
                <p className="cardNumber">04</p>
                <h2 className="cardTitle">Udemy<br></br><br></br><br></br></h2>
                <div className="tagContainer">
                  <span className="tag">Java</span>
                  <span className="tag">SpringBoot</span>
                  <span className="tag">Web Development</span>
                  <span className="tag">ReactNative</span>
                </div>
                <button className="plusButton">+</button>
              </div>
              <div className="cardContainer">
                <p className="cardNumber">05</p>
                <h2 className="cardTitle">LinkedIn Learning<br></br><br></br><br></br></h2>
                <div className="tagContainer">
                  <span className="tag">React</span>
                </div>
                <span className="breaker"><br></br></span>
                <button className="plusButton">+</button>
              </div>
            </div>
            <p className="downloadCV">Download CV</p>
          <div className="contactMeShortCut">
            <img src={doubleArrow} alt="Arrows" />
            <p><a href="https://drive.google.com/uc?export=download&id=1FWjxtL3c2Jzi40U4DkmIeNQ9JT8Xh5IU" className="downloadBtn" download="GeraldFernandoCV.pdf">Download</a></p>
          </div>
        </div>
      </section>

      <section className="services">
        <div className="servicesboarderCenter">
          <div className="serviceTopic">
            <p className="servicesTopic">
              Services that <span className="TopicHighlight"><br />are tailored</span>
            </p>
          </div>
          <div className="contactMeShortCut">
            <img src={doubleArrow} alt="Arrows" />
            <p>Services</p>
          </div>
        </div>
      </section>
      <section className="services">
        <div className="CardBoarderCenter">
          <div className="cardContainer">
            <p className="cardNumber">01</p>
            <h2 className="cardTitle">Web/Software Development</h2>
            <div className="tagContainer">
              <span className="tag">Development</span>
              <span className="tag">Brand Guidelines</span>
              <span className="tag">Analysis</span>
              <span className="tag">Rebranding Services</span>
            </div>
            <button className="plusButton">+</button>
          </div>
          <div className="cardContainer">
            <p className="cardNumber">02</p>
            <h2 className="cardTitle">UI/UX <br></br>Design</h2>
            <div className="tagContainer">
              <span className="tag">Development</span>
              <span className="tag">Brand Guidelines</span>
              <span className="tag">Analysis</span>
              <span className="tag">Rebranding Services</span>
            </div>
            <button className="plusButton">+</button>
          </div>
          <div className="cardContainer">
            <p className="cardNumber">03</p>
            <h2 className="cardTitle">Graphics <br></br>Design</h2>
            <div className="tagContainer">
              <span className="tag">Development</span>
              <span className="tag">Brand Guidelines</span>
              <span className="tag">Analysis</span>
              <span className="tag">Rebranding Services</span>
            </div>
            <button className="plusButton">+</button>
          </div>
        </div>
      </section>


      
      <section className="creative">
        <div className="creativeboarderCenter">
          <div className="creativesTopic">
            <p className="creativeTopic">
              Work <span className="TopicHighlight"><br />showcase</span>
            </p>
          </div>
          <div className="contactMeShortCut">
            <img src={doubleArrow} alt="Arrows" />
            <p>Creativity</p>
          </div>
        </div>
      </section>
      <section className="creative">
          <div className="selectedWorksList">
            <div className="photo-grid">
              <div className="photo-item"><a href="https://www.evertea.net/" target="_blank"><img className="selectedWorksIMG" src={everTeaWeb} alt="Evertea" /></a></div>
              <div className="photo-item"><img className="selectedWorksIMG" src={zain} alt="zain" /></div>
              <div className="photo-item"><img className="selectedWorksIMG" src={skateboard} alt="skateboard" /></div>
              <div className="photo-item"><a href="https://github.com/ReidenRealm/w2052113-Cw-Tickets-Booking-App.git" target="_blank"><img className="selectedWorksIMG" src={ticketingSystem} alt="TicketingSystem" /></a></div>
              <div className="photo-item"><img className="selectedWorksIMG" src={boy} alt="boy" /></div>
              <div className="photo-item"><img className="selectedWorksIMG" src={rachelsFashion} alt="rachelsFashion" /></div>
            </div>
          </div>
      </section>

</div>
  );
};

export default About;